module.exports = __webpack_public_path__ + "img/chc_anniversary_2.d4c4f7ef.jpg";